module.exports = __webpack_public_path__ + "img/IMG-20200128-WA0004.ac2a9876.jpg";